import { Component } from '@angular/core';

@Component({
  selector: 'app-text-skelton',

  templateUrl: './text-skelton.component.html',
  styleUrl: './text-skelton.component.scss',
})
export class TextSkeltonComponent {}
